<template>
  <div class="p-the-c01-detail">
    <div class="p-the-c01-detail__section">
      <p class="p-the-c01-detail__section__title">商品説明</p>

      <TextSanitized
        v-if="commentIndex"
        :text="commentIndex"
        class="p-the-c01-detail__section__comment"
      />
      <TextSanitized
        v-if="commentDetailMain"
        :text="commentDetailMain"
        class="p-the-c01-detail__section__comment"
      />
      <TextSanitized
        v-if="commentDetailSub"
        :text="commentDetailSub"
        class="p-the-c01-detail__section__comment"
      />
      <TextSanitized
        v-if="commentDetailSubSecond"
        :text="commentDetailSubSecond"
        class="p-the-c01-detail__section__comment"
      />
    </div>
    <div class="p-the-c01-detail__section">
      <p class="p-the-c01-detail__section__title">商品詳細</p>
      <div class="p-the-c01-detail__details">
        <p class="p-the-c01-detail__details__text">JAN: {{ janCode }}</p>
        <p v-if="saleStartDate" class="p-the-c01-detail__details__text">
          販売開始日: {{ saleStartDate }}
        </p>
        <p v-if="saleEndDate" class="p-the-c01-detail__details__text">
          販売終了日: {{ saleEndDate }}
        </p>
        <template v-if="category">
          <div class="p-the-c01-detail__details__category">
            <p class="p-the-c01-detail__details__text">カテゴリ</p>
            <p class="p-the-c01-detail__details__text">
              <span>{{ category }}</span>
              <template v-if="categoryChild">
                <span>></span>
                <span>{{ categoryChild }}</span>
              </template>
            </p>
          </div>
        </template>
      </div>
      <div class="p-the-c01-detail__section__note">
        商品は都合により予告なく変更または終了となる場合がございます。予めご了承ください。
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import TextSanitized from "@/common/components/atoms/TextSanitized.vue";

@Options({
  props: {
    commentIndex: { type: String, required: false, default: "" },
    commentDetailMain: { type: String, required: false, default: "" },
    commentDetailSub: { type: String, required: false, default: "" },
    commentDetailSubSecond: { type: String, required: false, default: "" },
    janCode: { type: String, required: false, default: "" },
    saleStartDate: { type: String, required: false, default: "" },
    saleEndDate: { type: String, required: false, default: "" },
    category: { type: String, required: false, default: "" },
    categoryChild: { type: String, required: false, default: "" }
  },
  components: {
    TextSanitized
  }
})
export default class TheC01ItemDetail extends Vue {
  commentIndex!: string;
  commentDetailMain!: string;
  commentDetailSub!: string;
  commentDetailSubSecond!: string;
  janCode!: string;
  saleStartDate!: string;
  saleEndDate!: string;
  category!: string;
  categoryChild!: string;
}
</script>

<style lang="scss" scoped>
.p-the-c01-detail {
  &__section {
    padding: rem(24) 0 rem(32);
    border-top: px(1) solid $common-gray-border;

    &__title {
      font-size: rem(20);
      font-weight: bold;
    }

    &__comment {
      @include text__body--s;
      color: $common-black-sub;
      margin-top: rem(24);
      line-height: 1.5;
    }

    &__note {
      @include text__body--s;
      color: $common-black-sub;
      margin-top: rem(16);
    }
  }

  &__details {
    padding: rem(16);
    border: px(1) solid $common-gray-border;
    max-width: rem(272);
    margin-top: rem(24);
  }

  &__details__text {
    @include text__body--s;
    color: $common-black-sub;
  }

  &__details__category {
    margin-top: rem(8);
  }
}
</style>
